import { useRouteError } from 'react-router';
import { AppError } from '../../../lib/errors';

export default function ClientError() {
  const error = useRouteError();

  if (error instanceof AppError) {
    return (
      <div className="flex flex-col items-center justify-center h-full gap-6 p-6 text-center">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-semibold">Something went wrong</h1>
          <p className="text-muted-foreground">{error.message}</p>
        </div>
        <div className="rounded-md border bg-stone-100 dark:bg-stone-800 px-6 py-4 text-sm text-stone-700 dark:text-stone-200 text-left space-y-1">
          <p>
            <span className="font-medium">Status:</span> {error.status}
          </p>
          <p>
            <span className="font-medium">Code:</span> {error.code}
          </p>
        </div>
      </div>
    );
  }

  console.error(error);
  return (
    <div className="flex flex-col items-center justify-center h-full gap-2 p-6 text-center">
      <h1 className="text-2xl font-semibold">Unexpected error</h1>
      <p className="text-muted-foreground">Please try again later.</p>
    </div>
  );
}
